import type { ReactNode } from "react";

export function PageLayout({
  title,
  children,
  footer,
}: {
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="mx-auto flex min-h-full max-w-md flex-col">
      {title ? (
        <header className="sticky top-0 z-10 border-b border-neutral-200 bg-white px-4 py-3">
          <h1 className="text-base font-semibold">{title}</h1>
        </header>
      ) : null}
      <main className="flex-1 px-4 py-4">{children}</main>
      {footer ? (
        <footer className="border-t border-neutral-200 bg-white px-4 py-3">{footer}</footer>
      ) : null}
    </div>
  );
}
